// extracted by mini-css-extract-plugin
module.exports = {"renewDialogContent":"styles_renewDialogContent__3tclM","renewDialogButtons":"styles_renewDialogButtons__39_Di"};